import logger from '@/logger';

export function migrate(objectType, jsonObj, migrations, ...extra) {
    const startVersion = Number(jsonObj.version ?? 0);
    for (const action of migrateLoop(objectType, jsonObj, migrations, ...extra))
        action();

    return jsonObj.version - startVersion;
}

export async function migrateAsync(objectType, jsonObj, migrations, ...extra) {
    const startVersion = Number(jsonObj.version ?? 0);
    for (const action of migrateLoop(objectType, jsonObj, migrations, ...extra))
        await action();

    return jsonObj.version - startVersion;
}

function* migrateLoop(objectType, jsonObj, migrations, ...extra) {
    for (let version = Number(jsonObj.version ?? 0); version < migrations.length; ++version) {
        const nextVersion = version + 1;
        const handler = migrations[version];
        if (handler == null || typeof handler !== 'function') {
            logger.error('migration was not a function');
            return;
        }

        logger.log(`migrating '${objectType}' to version #${nextVersion} (${handler.name})`);
        
        try {
            yield () => handler(jsonObj, nextVersion, ...extra);
            jsonObj.version = nextVersion;
        } catch (e) {
            logger.error(`Error in migration #${nextVersion} (${handler.name}) for object '${objectType}'; further migrations will not be run.`);
            logger.error(e);
            return;
        }
    }
}